import { ToastController, Platform } from '@ionic/angular';
// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';

// install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation]);
import { SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { SubSink } from 'subsink';
import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { PublicApiService } from 'src/app/services/public/public-api.service';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { BroadcastService } from 'src/app/services/share/broadcast.service';
import { Geolocation } from '@capacitor/geolocation';
import { AdsService } from 'src/app/services/ads/ads.service';
import { PlatformService } from 'src/app/services/platform/platform.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {
  latitude: any;
  longitude: any;
  // center: google.maps.LatLngLiteral = {lat: 39.103119, lng: -84.512016};
  center = sessionStorage.getItem('location')
    ? {
        lat: JSON.parse(sessionStorage.getItem('location')).latitude,
        lng: JSON.parse(sessionStorage.getItem('location')).longitude,
      }
    : { lat: 39.103119, lng: -84.512016 };

  isMobileDevice: boolean;
  isMobileApp: boolean;
  @ViewChild(MapInfoWindow) infoWindowsView: MapInfoWindow;

  subscription = new SubSink();
  venues: any;
  bands: any;
  profilePlaceholder: string = '/assets/images/profile-placeholder.png';
  bucket_url: string = environment.s3_bucket_url;
  venueData: any;
  specials: any;
  video_url: SafeUrl = '';
  info_content: string = '';
  userLogged: Subject<boolean>;
  is_user_logged_in: boolean = false;
  user_id: string = '';
  user_lat: string = '';
  user_long: string = '';
  showNearEventsDropdown: boolean = false;
  showSpinner: boolean = false;

  display: any;
  // center: google.maps.LatLngLiteral = {lat: 39.103119, lng: -84.512016};
  zoom = 13;
  // bandsmarkerOptions: google.maps.MarkerOptions = {
  //   draggable: false,
  //   icon: 'https://cll-stage.s3.us-east-2.amazonaws.com/map-icons/travel.png',
  // };
  // venuesmarkerOptions: google.maps.MarkerOptions = {
  //   draggable: false,
  //   icon: 'https://cll-stage.s3.us-east-2.amazonaws.com/map-icons/vacant-land.png',
  // };
  bandMarkerPositions: google.maps.LatLngLiteral[] = [];
  venueMarkerPositions: google.maps.LatLngLiteral[] = [];
  bandPositions: any = [];

  isAgeCheckPopoverOpen: boolean = false;

  dob: string = null;
  date_pipe = new DatePipe('en-us');
  threeYearsBeforeDate: string = moment().subtract(3,'years').format('YYYY-MM-DD');

  // public openInfoWindow(marker: MapMarker, msg) {
  //   this.info_content = msg;
  //   this.infoWindowsView.open(marker, info_content);
  // }

  public openInfoWindow(marker: MapMarker, msg: string) {
    this.info_content = msg;
    this.infoWindowsView.open(marker);
  }

  constructor(
    private router: Router,
    private publicService: PublicApiService,
    private auth: AuthService,
    private apiService: ApiService,
    private toast: ToastController,
    private broadcastService: BroadcastService,
    private adsService: AdsService,
    private platform: PlatformService,
    private route: ActivatedRoute
  ) {
    Window['myComponent'] = this;
    this.isMobileDevice = this.platform.isMobile();
    this.isMobileApp = this.platform.isMobileApp();
  }

  ngOnInit() {}

  preventScroll(ele) {
    // console.log("allowScroll");
    const content = ele.closest('ion-content');
    if (content) {
      content.style.setProperty('--overflow', 'hidden');
    }
  }

  allowScroll(ele) {
    // console.log("allowScroll");
    const content = ele.closest('ion-content');
    if (content) {
      content.style.setProperty('--overflow', 'inherit');
    }
  }

  ionViewDidEnter() {
    if (this.isUserLoggedIn()) {
      this.showNearEventsDropdown = true;
    }

    if (this.isMobileApp && this.hasAgePopoverParams()) {
      this.showAgeVerifyPopover();
    }

    let location = JSON.parse(sessionStorage.getItem('location'));
    if (location === undefined || location === null) {
      this.getCurrentLocation();
    }

    this.subscription.sink = this.broadcastService.coordinate$.subscribe(
      (res: any) => {
        this.latitude = res.coordinate.latitude;
        this.longitude = res.coordinate.longitude;
        this.getHomeData();
        this.getEvents();
      }
    );

    this.getHomeData();
    this.getEvents();


  }

  ionViewWillLeave() {
    this.subscription.unsubscribe();
  }

  showAgeVerifyPopover() {
    if (!this.getCookie('allowOver21Ads')) {
      this.isAgeCheckPopoverOpen = true;
    }
  }

  hasAgePopoverParams():boolean {
    let hasParams = false;
    this.route.queryParams.subscribe(params => {
      hasParams = params['showAgePopover'] ? true : false;
    });
    return hasParams;
  }

  checkUserLocation() {
    const storage_data = JSON.parse(localStorage.getItem('user_profile'));
    if (storage_data !== undefined && storage_data !== null) {
      if (storage_data.lat !== null && storage_data.long !== null) {
        this.showNearEventsDropdown = true;
        this.user_lat = storage_data.lat;
        this.user_long = storage_data.long;
      }
    }
  }

  calculateAge() {
    console.log("date of birth ==> ",this.dob);
    var current_year = moment().year();
    var selected_year = moment(this.dob).format('YYYY');
    var age = current_year - parseInt(selected_year);
    console.log("age ==> ", age);
    if (age >= 21) {
      this.setOver21AdsCookie();
    } else {
      this.setUnder21AdsCookie();
    }
  }

  async getHomeData() {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn()) {
        this.apiService
          .get(`home/user?lat=${this.latitude}&long=${this.longitude}`)
          .subscribe((res: any[]) => {
            this.venues = res['venues'];
            this.bands = res['bands'];
            // console.log("response =======>", res);
          });
      } else {
        this.publicService
          .get(`home?lat=${this.latitude}&long=${this.longitude}`)
          .subscribe((res: any[]) => {
            this.venues = res['venues'];
            this.bands = res['bands'];
            // console.log("band marker positions", this.bandPositions);
            // console.log("venue marker positions", this.venueMarkerPositions);
          });
      }
    } else {
      if (this.isUserLoggedIn()) {
        this.apiService.get('home/user').subscribe((res: any[]) => {
          this.venues = res['venues'];
          this.bands = res['bands'];
          // console.log("response =======>", res);
        });
      } else {
        this.publicService.get('home').subscribe((res: any[]) => {
          this.venues = res['venues'];
          this.bands = res['bands'];
          // console.log("band marker positions", this.bandPositions);
          // console.log("venue marker positions", this.venueMarkerPositions);
        });
      }
    }


  }

  getEvents() {
    this.showSpinner = true;
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn()) {
        this.apiService
          .get(`events?lat=${this.latitude}&long=${this.longitude}`)
          .subscribe((res: any) => {
            this.showSpinner = false;
            let events = res['data'];
            if(res.sliders && res.sliders.bands && res.sliders.bands.length > 0){
              this.bands = res.sliders.bands;
            }
            if(res.sliders && res.sliders.venues && res.sliders.venues.length > 0){
              this.venues = res.sliders.venues;
            }
            if (events.length == 0) {
              this.presentErrorToast('No events found');
            }
            this.showEventsOnMap(events);
          });
      } else {
        this.publicService
          .get(`events?lat=${this.latitude}&long=${this.longitude}`)
          .subscribe((res: any) => {
            this.showSpinner = false;
            let events = res['data'];
            if(res.sliders && res.sliders.bands && res.sliders.bands.length > 0){
              this.bands = res.sliders.bands;
            }
            if(res.sliders && res.sliders.venues && res.sliders.venues.length > 0){
              this.venues = res.sliders.venues;
            }
            if (events.length == 0) {
              this.presentErrorToast('No events found');
            }
            this.showEventsOnMap(events);
          });
      }
    } else {
      if (this.isUserLoggedIn()) {
        this.apiService.get('events').subscribe((res: any[]) => {
          this.showSpinner = false;
          let events = res['data'];
          if (events.length == 0) {
            this.presentErrorToast('No events found');
          }
          this.showEventsOnMap(events);
        });
      } else {
        this.publicService.get('events').subscribe((res: any[]) => {
          this.showSpinner = false;
          let events = res['data'];
          if (events.length == 0) {
            this.presentErrorToast('No events found');
          }
          this.showEventsOnMap(events);
        });
      }
    }


  }
  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async getCurrentLocation() {
    try {
      const coordinates = await Geolocation.getCurrentPosition();
      // console.log('Current position: ', coordinates.coords);
      let location = {
        latitude: coordinates.coords.latitude,
        longitude: coordinates.coords.longitude,
      };
      sessionStorage.setItem('location', JSON.stringify(location));
      this.broadcastService.coordinate$.next({ coordinate: location });
    } catch (error) {
      console.error(error);
    }
  }

  showEventsOnMap(events) {
    this.bandMarkerPositions = [];
    this.center = sessionStorage.getItem('location')
      ? {
          lat: JSON.parse(sessionStorage.getItem('location')).latitude,
          lng: JSON.parse(sessionStorage.getItem('location')).longitude,
        }
      : { lat: 39.103119, lng: -84.512016 };
    // this.center = {
    //   lat: 39.103119,
    //   lng: -84.512016
    // };
    this.display = {
      lat: 39.103119,
      lng: -84.512016,
    };
    events.forEach((event) => {
      let profile_pic: string = event?.user?.user_account_information
        ?.profile_image
        ? this.bucket_url + event?.user?.user_account_information?.profile_image
        : this.profilePlaceholder;
      let slug = '';
      let icon = '';
      let options: any;
      if (event?.user?.account_type?.id == 1) {
        slug = 'band';
        icon = '../../../assets/icons/bands-marker.png';
      } else if (event?.user?.account_type?.id == 2) {
        slug = 'comedian';
        icon = '../../../assets/icons/comedians-marker.png';
      } else if (event?.user?.account_type?.id == 3) {
        slug = 'food-truck';
        icon = '../../../assets/icons/foodtruck-marker.png';
      } else if (event?.user?.account_type?.id == 4) {
        slug = 'user';
        icon = '../../../assets/icons/user-marker.png';
      } else if (event?.user?.account_type?.id == 5) {
        slug = 'venue';
        icon = '../../../assets/icons/venues-marker.png';
      } else if (event?.user?.account_type?.id == 6) {
        slug = 'comedy-club';
        icon = '../../../assets/icons/comedyclub-marker.png';
      } else if (event?.user?.account_type?.id == 7) {
        slug = 'artist';
        icon = '../../../assets/icons/artists-marker.png';
      }
      let date = moment(event.event_date).format('MMMM D, YYYY');
      let eventStartTime = '';
      let eventEndTime = '';
      let time = '';
      if (event.event_start_time !== null && event.event_end_time !== null) {
        eventStartTime = moment(event.event_start_time, 'HH:mm:ss').format(
          'hh:mm A'
        );
        eventEndTime = moment(event.event_end_time, 'HH:mm:ss').format(
          'hh:mm A'
        );
        time = eventStartTime + ' - ' + eventEndTime;
      } else {
        time = 'All Day';
      }
      let eventDescription: string = '';
      if (event.event_description !== '' && event.event_description !== null) {
        eventDescription = event.event_description;
      } else {
        eventDescription = 'N/A';
      }

      let msg =
        `<div class="bg-grunge p-3 flex map_window">
      <img class=" max-w-sm pr-4" src="` +
        profile_pic +
        `">
      <div class="text-center flex-1">
        <h1 class="uppercase">` +
        event?.event_title +
        `</h1>
        <a onclick="Window.myComponent.goToProfile('` +
        slug +
        `', '` +
        event?.user_id +
        `')" class="uppercase cursor-pointer">[View profile]</a>
      </div>
    </div>
    <div class="-mt-2 mx-2 bg-cll-danger map_info_event uppercase text-white">
      <p class="mb-2">
        <span class="text-white font-bold">Date & Time: </span>
        ` +
        date +
        ' ' +
        time +
        `
      </p>
      <p class="mb-2">
        <span class="text-white font-bold">Event Description: </span>
        ` +
        eventDescription +
        `
      </p>
      <p class="mb-5">
        <span class="text-white font-bold">Who: </span>
        ` +
        event?.user?.first_name +
        ' ' +
        event?.user?.last_name +
        `
      </p>
      <p class="mb-2">
        <span class="text-white flex justify-between">
          <span>
            <span class="font-bold">Where: </span>
            ` +
        event.where_event +
        `
          </span>`;
      if (event.distance) {
        msg +=
          `<span class="font-bold ml-2">` +
          event.distance +
          ' Miles away' +
          `</span>`;
      }
      msg +=
        `<p class="mb-5">
                    <a target="_blank" href="https://maps.google.com/?q=` +
        event.lat +
        `,` +
        event.long +
        `">` +
        event.event_address +
        `</a>
                    <span>
                      <ion-icon class="cursor-pointer" onclick="Window.myComponent.copyToClipboard('` +
        event.event_address +
        `')" name="copy-outline"></ion-icon>
                      <span id="custom-tooltip" class="capitalize text-black bg-white font-bold" style="padding: 2px 7px;  border-radius: 4px; display: none;">copied</span>
                    </span>
                  </p>
        </span>
      </p>
    </div>`;
      this.bandPositions.push({
        options: {
          draggable: false,
          slug: slug,
          icon: icon,
        },
        message: msg,
      });
      this.bandMarkerPositions.push({
        lat: Number(event.lat),
        lng: Number(event.long),
      });
      this.display = {
        lat: Number(event.lat),
        lng: Number(event.long),
      };
    });
  }

  goToProfile(slug, id) {
    this.router.navigate([slug + '/' + btoa(id)]);
  }

  async logOut() {
    await this.auth.logout();
    // this.popover.dismiss();
    this.router.navigate(['login']);
  }

  testCall() {
    // alert('function called');
  }
  isUserLoggedIn() {
    const storage_data = JSON.parse(localStorage.getItem('user_data'));
    if (storage_data !== undefined && storage_data !== null) {
      return true;
    } else {
      return false;
    }
  }

  playTrack(container_class) {
    document
      .querySelectorAll('.' + container_class + ' .play')
      .forEach((elem) => elem.classList.add('hidden'));
    document
      .querySelectorAll('.' + container_class + ' .pause')
      .forEach((elem) => elem.classList.remove('hidden'));
    const video = document.getElementById(
      container_class
    ) as HTMLVideoElement | null;

    if (video != null) {
      video.play();
    }
  }

  pauseTrack(container_class) {
    document
      .querySelectorAll('.' + container_class + ' .play')
      .forEach((elem) => elem.classList.remove('hidden'));
    document
      .querySelectorAll('.' + container_class + ' .pause')
      .forEach((elem) => elem.classList.add('hidden'));
    const video = document.getElementById(
      container_class
    ) as HTMLVideoElement | null;

    if (video != null) {
      video.pause();
    }
  }

  eventsNearYou(e) {
    let miles = e.srcElement.value;
    if (miles == -1) this.getEvents();
    else {
      let data = {
        miles: miles,
        // lat: this.user_lat,
        // long: this.user_long,
      };
      this.showSpinner = true;
      if (this.isLocationStored()) {
        this.apiService
          .post(
            `events/eventsNearInMiles?lat=${this.latitude}&long=${this.longitude}`,
            data
          )
          .subscribe((res: any) => {
            // this.showEventsOnMap(res['data']);
            // console.log("near me events", res['data']);
            if(res.sliders && res.sliders.bands && res.sliders.bands.length > 0){
              this.bands = res.sliders.bands;
            }
            if(res.sliders && res.sliders.venues && res.sliders.venues.length > 0){
              this.venues = res.sliders.venues;
            }

            let events = res['data'];
            this.bandMarkerPositions = [];
            this.bandPositions = [];
            this.showSpinner = false;
            if (events.length == 0) {
              this.presentErrorToast('No events found');
            }
            events.forEach((event) => {
              let profile_pic: string = event.profile_image
                ? this.bucket_url + event.profile_image
                : this.profilePlaceholder;
              let slug = '';
              let icon = '';
              let options: any;
              if (event.account_type_id == 1) {
                slug = 'band';
                icon = '../../../assets/icons/bands-marker.png';
              } else if (event.account_type_id == 2) {
                slug = 'comedian';
                icon = '../../../assets/icons/comedians-marker.png';
              } else if (event.account_type_id == 3) {
                slug = 'food-truck';
                icon = '../../../assets/icons/foodtruck-marker.png';
              } else if (event.account_type_id == 4) {
                slug = 'user';
                icon = '../../../assets/icons/user-marker.png';
              } else if (event.account_type_id == 5) {
                slug = 'venue';
                icon = '../../../assets/icons/venues-marker.png';
              } else if (event.account_type_id == 6) {
                slug = 'comedy-club';
                icon = '../../../assets/icons/comedyclub-marker.png';
              } else if (event.account_type_id == 7) {
                slug = 'artist';
                icon = '../../../assets/icons/artists-marker.png';
              }

              let date = moment(event.event_date).format('MMMM D, YYYY');
              let eventStartTime = '';
              let eventEndTime = '';
              let time = '';
              if (event.event_start_time !== null && event.event_end_time !== null) {
                eventStartTime = moment(event.event_start_time, 'HH:mm:ss').format(
                  'hh:mm A'
                );
                eventEndTime = moment(event.event_end_time, 'HH:mm:ss').format(
                  'hh:mm A'
                );
                time = eventStartTime + ' - ' + eventEndTime;
              } else {
                time = 'All Day';
              }
              let eventDescription: string = '';
              if (event.event_description !== '' && event.event_description !== null) {
                eventDescription = event.event_description;
              } else {
                eventDescription = 'N/A';
              }

              this.bandPositions.push({
                options: {
                  draggable: false,
                  slug: slug,
                  icon: icon,
                },
                message:
                  `<div class="bg-white p-3 flex map_window">
                <img class=" max-w-sm pr-4" src="` +
                  profile_pic +
                  `">
                <div class="text-center flex-1">
                  <h1 class="uppercase">` +
                  event?.event_title +
                  `</h1>
                  <a onclick="Window.myComponent.goToProfile('` +
                  slug +
                  `', '` +
                  event?.user_id +
                  `')" class="uppercase cursor-pointer">[View profile]</a>
                </div>
              </div>
              <div class="bg-cll-danger map_info_event uppercase text-white">
                <p class="mb-2">
                  <span class="text-white font-bold">Date & Time: </span>
                  ` +
                  date +
                  ' ' +
                  time +
                  `
                </p>
                <p class="mb-2">
                  <span class="text-white font-bold">Event Description: </span>
                  ` +
                  eventDescription +
                  `
                </p>
                <p class="mb-5">
                  <span class="text-white font-bold">Who: </span>
                  ` +
                  event.first_name +
                  ' ' +
                  event.last_name +
                  `
                </p>
                <p class="mb-2">
                  <span class="text-white flex justify-between">
                    <span>
                      <span class="font-bold">Where: </span>
                      ` +
                  event.where_event +
                  `
                    </span>
                    <span class="font-bold ml-2">` +
                  event.distance +
                  ` Miles away</span>
                    <p class="mb-5 address_link">
                      <a target="_blank" href="https://maps.google.com/?q=` +
                  event.lat +
                  `,` +
                  event.long +
                  `">` +
                  event.event_address +
                  `</a>
                      <span>
                        <ion-icon class="cursor-pointer" onclick="Window.myComponent.copyToClipboard('` +
                  event.event_address +
                  `')" name="copy-outline"></ion-icon>
                        <span id="custom-tooltip" class="capitalize text-black bg-white font-bold" style="padding: 2px 7px;  border-radius: 4px; display: none;">copied</span>
                      </span>
                    </p>
                  </span>
                </p>
              </div>`,
              });
              this.bandMarkerPositions.push({
                lat: Number(event.lat),
                lng: Number(event.long),
              });
              this.display = {
                lat: Number(event.lat),
                lng: Number(event.long),
              };
              this.center = {
                lat: Number(event.lat),
                lng: Number(event.long),
              };
            });
          });
      } else {
        this.apiService
          .post('events/eventsNearInMiles', data)
          .subscribe((res: any) => {
            // this.showEventsOnMap(res['data']);
            // console.log("near me events", res['data']);
            if(res.sliders && res.sliders.bands && res.sliders.bands.length > 0){
              this.bands = res.sliders.bands;
            }
            if(res.sliders && res.sliders.venues && res.sliders.venues.length > 0){
              this.venues = res.sliders.venues;
            }

            let events = res['data'];
            this.bandMarkerPositions = [];
            this.bandPositions = [];
            this.showSpinner = false;
            if (events.length == 0) {
              this.presentErrorToast('No events found');
            }
            events.forEach((event) => {
              let profile_pic: string = event.profile_image
                ? this.bucket_url + event.profile_image
                : this.profilePlaceholder;
              let slug = '';
              let icon = '';
              let options: any;
              if (event.account_type_id == 1) {
                slug = 'band';
                icon = '../../../assets/icons/bands-marker.png';
              } else if (event.account_type_id == 2) {
                slug = 'comedian';
                icon = '../../../assets/icons/comedians-marker.png';
              } else if (event.account_type_id == 3) {
                slug = 'food-truck';
                icon = '../../../assets/icons/foodtruck-marker.png';
              } else if (event.account_type_id == 4) {
                slug = 'user';
                icon = '../../../assets/icons/user-marker.png';
              } else if (event.account_type_id == 5) {
                slug = 'venue';
                icon = '../../../assets/icons/venues-marker.png';
              } else if (event.account_type_id == 6) {
                slug = 'comedy-club';
                icon = '../../../assets/icons/comedyclub-marker.png';
              } else if (event.account_type_id == 7) {
                slug = 'artist';
                icon = '../../../assets/icons/artists-marker.png';
              }
              this.bandPositions.push({
                options: {
                  draggable: false,
                  slug: slug,
                  icon: icon,
                },
                message:
                  `<div class="bg-white p-3 flex map_window">
                <img class=" max-w-sm pr-4" src="` +
                  profile_pic +
                  `">
                <div class="text-center flex-1">
                  <h1 class="uppercase">` +
                  event?.event_title +
                  `</h1>
                  <a onclick="Window.myComponent.goToProfile('` +
                  slug +
                  `', '` +
                  event?.user_id +
                  `')" class="uppercase cursor-pointer">[View profile]</a>
                </div>
              </div>
              <div class="bg-cll-danger map_info_event uppercase text-white">
                <p class="mb-2">
                  <span class="text-white font-bold">Date & Time: </span>
                  ` +
                  event?.event_date +
                  ' ' +
                  event.event_start_time +
                  ` - ` +
                  event.event_end_time +
                  `
                </p>
                <p class="mb-2">
                  <span class="text-white font-bold">Event Description: </span>
                  ` +
                  event.event_description +
                  `
                </p>
                <p class="mb-5">
                  <span class="text-white font-bold">Who: </span>
                  ` +
                  event.first_name +
                  ' ' +
                  event.last_name +
                  `
                </p>
                <p class="mb-2">
                  <span class="text-white flex justify-between">
                    <span>
                      <span class="font-bold">Where: </span>
                      ` +
                  event.where_event +
                  `
                    </span>
                    <span class="font-bold ml-2">` +
                  event.distance +
                  ` Miles away</span>
                    <p class="mb-5 address_link">
                      <a target="_blank" href="https://maps.google.com/?q=` +
                  event.lat +
                  `,` +
                  event.long +
                  `">` +
                  event.event_address +
                  `</a>
                      <span>
                        <ion-icon class="cursor-pointer" onclick="Window.myComponent.copyToClipboard('` +
                  event.event_address +
                  `')" name="copy-outline"></ion-icon>
                        <span id="custom-tooltip" class="capitalize text-black bg-white font-bold" style="padding: 2px 7px;  border-radius: 4px; display: none;">copied</span>
                      </span>
                    </p>
                  </span>
                </p>
              </div>`,
              });
              this.bandMarkerPositions.push({
                lat: Number(event.lat),
                lng: Number(event.long),
              });
              this.display = {
                lat: Number(event.lat),
                lng: Number(event.long),
              };
              this.center = {
                lat: Number(event.lat),
                lng: Number(event.long),
              };
            });
          });
      }
    }
  }

  copyToClipboard = (str) => {
    if (!navigator.clipboard) {
      const el = document.createElement('textarea');
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      document.getElementById('custom-tooltip').style.display = 'inline';
      setTimeout(function () {
        document.getElementById('custom-tooltip').style.display = 'none';
      }, 1000);
    } else {
      navigator.clipboard.writeText(str).then(
        function () {
          document.getElementById('custom-tooltip').style.display = 'inline';
          setTimeout(function () {
            document.getElementById('custom-tooltip').style.display = 'none';
          }, 1000);
        },
        function (err) {
          console.error('Async: Could not copy text: ', err);
        }
      );
    }
  };

  isLocationStored() {
    const location_storage = JSON.parse(sessionStorage.getItem('location'));
    if (location_storage !== undefined && location_storage !== null) {
      this.latitude = location_storage.latitude;
      this.longitude = location_storage.longitude;
      return true;
    } else {
      return false;
    }
  }

  getCookie(c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1)
          c_end = document.cookie.length;
        // console.log("cookie ===> ",unescape(document.cookie.substring(c_start, c_end)));
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }

  closeAgeCheckPopover() {
    this.isAgeCheckPopoverOpen = false;
    // return false;
  }

  setOver21AdsCookie() {
    document.cookie = "allowOver21Ads=true";
    this.adsService.changeAdsStatus(true);
    // console.log("home ads changed over");

    this.closeAgeCheckPopover();
  }

  setUnder21AdsCookie() {
    document.cookie = "allowOver21Ads=false";
    this.adsService.changeAdsStatus(true);
    // console.log("home ads changed under");
    this.closeAgeCheckPopover();
  }

}
